<template>
    <div class="page-content">
        <b-row align-h="end">
            <b-col cols="auto">
                <b-btn size="sm" variant="primary" @click="openRealtimeEntries">Ingresos en tiempo real</b-btn>
            </b-col>
        </b-row>
        <b-tabs content-class="mt-3" v-model="activeTab">
            <b-tab title="Personas y Vehículos">
                <div class="content-fluid">
                    <app-title :text="`Ingreso de ${entryTypeName}`" />
                    <div class="w-50">
                        <app-people-vehicles-auto-complete v-if="!document" v-model="document" />
                    </div>
                    <component :is="entryType" :document="document"></component>
                </div>
            </b-tab>
            <b-tab title="Lector Cédulas" v-if="moduleEnabled('lector-de-cedulas')">
                <app-barcode-reader @start-entry="onStartEntry" />
            </b-tab>
            <b-tab title="Vehiculos de carga" v-if="moduleEnabled('vehiculos-de-carga')">
                <app-cargo-vehicle-entry-page />
            </b-tab>
        </b-tabs>

    </div>
</template>
<script>
    import PersonEntryFrom from './Person/PersonEntryForm.vue';
    import VehicleEntryForm from './Vehicle/VehicleEntryForm.vue';
    import { alphaSpaces, alphaNumericNoSpaces } from '../../../../utils/CustomValidators';
    import { required, email, numeric } from 'vuelidate/lib/validators';
    import PeopleVehiclesAutoComplete from '../../../UI/Controls/PeopleVehiclesAutoComplete/PeopleVehiclesAutoComplete.vue';
    import BarcodeReader from './BarcodeReader/BarcodeReader';
    import CargoVehicleEntryPage from './CargoVehicle/CargoVehicleEntriesPage';
    export default {
        components: {
            appPersonEntryForm: PersonEntryFrom,
            appVehicleEntryForm: VehicleEntryForm,
            appPeopleVehiclesAutoComplete: PeopleVehiclesAutoComplete,
            appBarcodeReader: BarcodeReader,
            appCargoVehicleEntryPage: CargoVehicleEntryPage
        },
        validations: {
            document: {required, alphaNumericNoSpaces }
        },
        data(){
            return {
                document: '',
                activeTab: 0
            }
        },
        watch: {
            activeTab(val) {
                this.$bus.$emit('barcode-reader.clear');
            }
        },
        computed: {
            entryType(){
                if(!this.document || !(/^[a-zA-Z0-9]+$/.test(this.document))){
                    this.document = '';
                    !!this.$refs.entryDocument && (this.$refs.entryDocument.value = '');
                    return null;
                }
                const x = this.document.toString().charAt(0);
                return x.toLowerCase() != x.toUpperCase()?'appVehicleEntryForm':'appPersonEntryForm';
            },
            entryTypeName(){
                if(!this.entryType) return 'persona o vehículo';

                return this.entryType === 'appVehicleEntryForm'? 'Vehículo': 'Persona';
            }
        },
        methods: {
            onStartEntry(document) {
                this.document = document;
                this.activeTab = 0;
            },
            openRealtimeEntries () {
                const routeData = this.$router.resolve({name: 'realtimeEntries'})
                window.open(routeData.href)

            }
        },
        created(){
            this.load('visitorTypes');

            this.$bus.$on('entry.reset', (e) => {
                this.document = '';
                !!this.$refs.entryDocument && (this.$refs.entryDocument.value = '');
            });

            // this.$bus.$on('entry.setDocument', (document) => {
            //     this.document = document;
            // })
        }
    }
</script>
